const ru: Record<string, string> = {
  'golf.common.active': 'Активен',
  'golf.common.admin': 'Администратор',
  'golf.common.age': 'Возраст',
  'golf.common.alert': 'Оповещение',
  'golf.common.amount': 'Сумма',
  'golf.common.cancel': 'Отмена',
  'golf.common.close': 'Закрыть',
  'golf.common.create': 'Создать',
  'golf.common.created': 'Создано',
  'golf.common.days_fri': 'Пт',
  'golf.common.days_mon': 'Пн',
  'golf.common.days_sat': 'Сб',
  'golf.common.days_sun': 'Вс',
  'golf.common.days_thu': 'Чт',
  'golf.common.days_tue': 'Вт',
  'golf.common.days_wed': 'Ср',
  'golf.common.delete': 'Удалить',
  'golf.common.delete_confirm': 'Вы уверены, что хотите удалить зону «{name}»?',
  'golf.common.details': 'Детали',
  'golf.common.discard_changes': 'Отменить изменения',
  'golf.common.draft': 'Черновик',
  'golf.common.driving_experience': 'Водительский стаж',
  'golf.common.edit': 'Редактировать',
  'golf.common.email': 'Электронная почта',
  'golf.common.grant': 'Предоставить',
  'golf.common.hourly': 'ПОЧАСОВАЯ',
  'golf.common.image_not_available': 'Изображение недоступно',
  'golf.common.name': 'Имя',
  'golf.common.no': 'Нет',
  'golf.common.not_configured': 'Не настроено',
  'golf.common.not_uploaded': 'Не загружено',
  'golf.common.parking': 'Парковка',
  'golf.common.payment_card': 'КАРТА',
  'golf.common.phone': 'Телефон',
  'golf.common.points': 'Точки',
  'golf.common.points_count': 'Точек: {count}',
  'golf.common.points_json': 'Точки (JSON)',
  'golf.common.points_json_hint':
    'Массив объектов {lat, lng} для вершин полигона',
  'golf.common.protocol_4point': 'ПРОТОКОЛ ПО 4 ТОЧКАМ',
  'golf.common.quantity': 'Количество',
  'golf.common.reason': 'Причина',
  'golf.common.revoke': 'Отозвать',
  'golf.common.save': 'Сохранить',
  'golf.common.save_changes': 'Сохранить изменения',
  'golf.common.select': 'Выберите',
  'golf.common.select_type': 'Выберите тип',
  'golf.common.status': 'Статус',
  'golf.common.status_update_failed': 'Не удалось обновить статус',
  'golf.common.status_updated': 'Статус обновлен',
  'golf.common.summary': 'Сводка',
  'golf.common.system': 'Система',
  'golf.common.today': 'Сегодня',
  'golf.common.type': 'Тип',
  'golf.common.units': 'Единицы',
  'golf.common.update': 'Обновить',
  'golf.common.updated': 'Обновлено',
  'golf.common.user': 'Пользователь',
  'golf.common.yes': 'Да',
  'golf.dashboard.active_trips': 'АКТИВНЫЕ ПОЕЗДКИ',
  'golf.dashboard.approved_trips': 'ОДОБРЕННЫЕ ПОЕЗДКИ',
  'golf.dashboard.ready_to_start': 'Готовы к старту',
  'golf.dashboard.daily': 'По дням',
  'golf.dashboard.dispatch_service': 'Направить сервисную бригаду',
  'golf.dashboard.end_date': 'Дата окончания',
  'golf.dashboard.filtered_range': 'Выбранный период',
  'golf.dashboard.fleet_status': 'СОСТОЯНИЕ АВТОПАРКА',
  'golf.dashboard.live_on_course': 'Сейчас на поле',
  'golf.dashboard.log_archive_future':
    'Архив журналов станет доступен в следующих обновлениях',
  'golf.dashboard.low_battery_alerts': 'с низким зарядом батареи',
  'golf.dashboard.notifications': 'Уведомления',
  'golf.dashboard.pending_trips': 'ОЖИДАЮЩИЕ ПОЕЗДКИ',
  'golf.dashboard.period_revenue': 'ВЫРУЧКА ЗА ПЕРИОД',
  'golf.dashboard.prev_week_growth': '+5,2% к прошлой неделе',
  'golf.dashboard.requires_verification': 'Требуется проверка',
  'golf.dashboard.service_request': 'Заявка на обслуживание № 12',
  'golf.dashboard.start_date': 'Дата начала',
  'golf.dashboard.tire_pressure_warning':
    'Предупреждение о давлении в шинах: гольф-кар GC-002 (VIP).',
  'golf.dashboard.title': 'Панель управления',
  'golf.dashboard.traffic_analytics': 'Аналитика динамики аренды',
  'golf.dashboard.view_log_archive': 'Открыть архив журналов →',
  'golf.financial.action_charge': 'Списать',
  'golf.financial.action_freeze': 'Заблокировать',
  'golf.financial.action_refund': 'Вернуть',
  'golf.financial.action_unfreeze': 'Разблокировать',
  'golf.financial.badge_held': '[ЗАБЛОКИРОВАН]',
  'golf.financial.badge_released': '[РАЗБЛОКИРОВАН]',
  'golf.financial.charged': 'СПИСАНО',
  'golf.financial.col_deposit_status': 'СТАТУС ДЕПОЗИТА',
  'golf.financial.col_outstanding': 'ЗАДОЛЖЕННОСТЬ',
  'golf.financial.col_rental_fee': 'ПЛАТА ЗА АРЕНДУ',
  'golf.financial.col_renter': 'АРЕНДАТОР',
  'golf.financial.col_timestamp': 'ДАТА И ВРЕМЯ',
  'golf.financial.export_financial_report': 'Экспортировать финансовый отчет',
  'golf.financial.exporting_report': 'Экспорт финансового отчета...',
  'golf.financial.frozen': 'ЗАБЛОКИРОВАНО',
  'golf.financial.growth': 'РОСТ +4%',
  'golf.financial.last_month': 'Прошлый месяц',
  'golf.financial.manual_amount': 'РУЧНОЙ ВВОД СУММЫ (₼)',
  'golf.financial.operation_type': 'ТИП ОПЕРАЦИИ',
  'golf.financial.payment_activity': 'Платежная активность',
  'golf.financial.please_enter_amount': 'Пожалуйста, введите сумму',
  'golf.financial.recent_deposit_service_desc':
    'Недавние операции по депозиту и сервису этого арендатора.',
  'golf.financial.recent_transactions': 'Последние транзакции',
  'golf.financial.refunded': 'ВОЗВРАЩЕНО',
  'golf.financial.renter': 'АРЕНДАТОР',
  'golf.financial.select_range': 'Выберите период',
  'golf.financial.service_fee': 'Плата за обслуживание',
  'golf.financial.settlement': 'Расчет',
  'golf.financial.target_account': 'ЦЕЛЕВОЙ СЧЕТ',
  'golf.financial.this_month': 'Этот месяц',
  'golf.financial.this_year': 'Этот год',
  'golf.financial.all_time': 'Все время',
  'golf.financial.title': 'Финансовые отчеты и биллинг',
  'golf.financial.total_revenue': 'ОБЩАЯ ВЫРУЧКА',
  'golf.financial.transactions_title': 'ТРАНЗАКЦИИ',
  'golf.financial.valid_amount': 'Пожалуйста, введите корректную сумму',
  'golf.fleet.actions': 'ДЕЙСТВИЯ',
  'golf.fleet.active_in_resort': 'Активные на курорте',
  'golf.fleet.add_make': 'Добавить марку',
  'golf.fleet.add_model': 'Добавить модель',
  'golf.fleet.all': 'Все',
  'golf.fleet.asset_dialog_title': 'Единица: {id}',
  'golf.fleet.asset_info': 'Информация о единице техники',
  'golf.fleet.assigned_make': 'НАЗНАЧЕННАЯ МАРКА',
  'golf.fleet.basic_info': 'Основная информация',
  'golf.fleet.battery': 'Батарея:',
  'golf.fleet.battery_label': '(БАТАРЕЯ)',
  'golf.fleet.browse': 'выберите',
  'golf.fleet.capacity': 'ВМЕСТИМОСТЬ',
  'golf.fleet.car_details': 'Сведения о гольф-каре',
  'golf.fleet.change_deployment_zone':
    'Нажмите, чтобы изменить зону размещения',
  'golf.fleet.clear_zone_assignment': 'Сбросить назначение зоны',
  'golf.fleet.click_select_zone':
    'Нажмите, чтобы выбрать из зон, созданных администратором',
  'golf.fleet.click_to_connect': 'Нажмите для подключения',
  'golf.fleet.connect_wialon_dialog': 'Подключить GPS-блок Wialon',
  'golf.fleet.connected_status': 'Подключено:',
  'golf.fleet.count_models': 'Моделей: {count}',
  'golf.fleet.create_profile_subtitle':
    'Добавьте новую модель гольф-кара в автопарк',
  'golf.fleet.create_profile_title': 'Создать профиль гольф-кара',
  'golf.fleet.deployment_logs_hint':
    'Журнал размещения будет создан после сохранения.',
  'golf.fleet.detailed_description_placeholder':
    'Введите подробное описание этой модели гольф-кара...',
  'golf.fleet.disconnect': 'Отключить',
  'golf.fleet.draft': 'Черновик',
  'golf.fleet.drop_image': 'Перетащите изображение или',
  'golf.fleet.eg_gc001': 'напр., GC-001',
  'golf.fleet.eg_make_name': 'напр., Denago XL или Club Car Tempo',
  'golf.fleet.eg_model_seats': 'напр., RXV 4-местный',
  'golf.fleet.eg_seats_count': 'напр., 4 или 2',
  'golf.fleet.eg_stall_number': 'напр., A-12',
  'golf.fleet.eg_unit_id': 'напр., 123456',
  'golf.fleet.eg_unit_name': 'напр., Golf Car 1',
  'golf.fleet.filter_by_asset_status': 'Фильтр по статусу единицы техники:',
  'golf.fleet.filter_by_status': 'Фильтр по статусу:',
  'golf.fleet.fleet_status_logs': 'Журнал статусов автопарка',
  'golf.fleet.growth_plus4': 'РОСТ +4%',
  'golf.fleet.initial_asset': 'Первая единица техники',
  'golf.fleet.iot_telemetry': 'IOT-ТЕЛЕМЕТРИЯ',
  'golf.fleet.last_telemetry': 'Последняя телеметрия:',
  'golf.fleet.last_update': 'Последнее обновление:',
  'golf.fleet.location': 'Местоположение:',
  'golf.fleet.low_battery_alerts': 'Низкий заряд / сервисные оповещения',
  'golf.fleet.make_created_success': 'Марка гольф-каров успешно создана!',
  'golf.fleet.make_name': 'Название марки',
  'golf.fleet.make_updated_success': 'Марка гольф-каров успешно обновлена!',
  'golf.fleet.model_created_success': 'Модель успешно создана!',
  'golf.fleet.model_id': 'ID МОДЕЛИ',
  'golf.fleet.model_name': 'Модель',
  'golf.fleet.model_updated_success': 'Модель успешно обновлена!',
  'golf.fleet.no_zone_assigned': 'Зона не назначена',
  'golf.fleet.physical_assets': 'ЕДИНИЦЫ ТЕХНИКИ',
  'golf.fleet.profile_created_success': 'Профиль гольф-кара успешно создан!',
  'golf.fleet.profile_photo': 'Фото профиля',
  'golf.fleet.range': 'Запас хода',
  'golf.fleet.range_km': 'Запас хода (км)',
  'golf.fleet.ready': 'ГОТОВА',
  'golf.fleet.resort_deployment_zone': 'Зона размещения на курорте',
  'golf.fleet.search_wialon_placeholder': 'Поиск по ID или названию...',
  'golf.fleet.select_from_catalog': 'Выберите из каталога...',
  'golf.fleet.showing_active_assets':
    'Показаны {start}–{end} из {total} активных единиц',
  'golf.fleet.showing_active_profiles':
    'Показаны {start}–{end} из {total} активных профилей',
  'golf.fleet.status': 'СТАТУС',
  'golf.fleet.status_active': 'Активен',
  'golf.fleet.status_in_use': 'Используется',
  'golf.fleet.status_inactive': 'Неактивен',
  'golf.fleet.status_maintenance': 'На обслуживании',
  'golf.fleet.tab_makes': 'Марки гольф-каров',
  'golf.fleet.tab_models': 'Модели гольф-каров',
  'golf.fleet.tariff_dialog_title': 'Тариф: {name}',
  'golf.fleet.tariffs': 'ТАРИФЫ',
  'golf.fleet.telemetry_data': 'Данные телеметрии',
  'golf.fleet.title': 'Управление автопарком',
  'golf.fleet.total_fleet_models': 'Всего моделей в автопарке',
  'golf.fleet.total_inventory': 'ВСЕГО ЕДИНИЦ',
  'golf.fleet.total_models': 'Всего моделей в автопарке',
  'golf.fleet.unique_chassis_hint':
    'Укажите уникальный номер шасси или внутреннюю нумерацию курорта.',
  'golf.fleet.unit_id': 'ID объекта',
  'golf.fleet.upload_images_hint':
    'Загрузите 4 фотографии гольф-кара (спереди, сзади, слева, справа). До 10 МБ каждая.',
  'golf.fleet.view': 'Просмотреть',
  'golf.fleet.wialon_unit_id': 'ID объекта Wialon:',
  'golf.fleet.wialon_unit_name': 'НАЗВАНИЕ ОБЪЕКТА WIALON',
  'golf.header.language_az': 'Azərbaycan',
  'golf.header.language_en': 'English',
  'golf.header.language_ru': 'Русский',
  'golf.header.pending_trips_title': 'Ожидающие заявки на поездки',
  'golf.header.search_placeholder':
    'Поиск по гольф-кару, пользователю, поездке...',
  'golf.header.select_language': 'Выберите язык',
  'golf.header.sign_out': 'Выйти',
  'golf.map.add_area': 'Добавить зону',
  'golf.map.alert_area_created_success': 'Зона оповещения успешно создана',
  'golf.map.alert_area_deleted_success': 'Зона оповещения успешно удалена',
  'golf.map.alert_area_name_placeholder': 'Название зоны оповещения',
  'golf.map.alert_area_updated_success': 'Зона оповещения успешно обновлена',
  'golf.map.alert_areas_title': 'Зоны оповещения',
  'golf.map.area_created_success': 'Зона успешно создана',
  'golf.map.area_deleted_success': 'Зона успешно удалена',
  'golf.map.area_instructions':
    'Перетаскивайте маркеры, чтобы изменить границы зоны. Чтобы удалить точку, щелкните по ней правой кнопкой мыши.',
  'golf.map.area_must_have_3_points': 'Зона должна содержать не менее 3 точек',
  'golf.map.area_name_placeholder': 'Название зоны',
  'golf.map.area_updated_success': 'Зона успешно обновлена',
  'golf.map.available': 'Доступно:',
  'golf.map.available_assets': 'Доступно единиц:',
  'golf.map.create_new_alert_area': 'Создать новую зону оповещения',
  'golf.map.create_new_area': 'Создать новую зону',
  'golf.map.drawing_instructions_create':
    'Нажимайте на карту для добавления точек. Нажмите на первую точку или «Завершить» для замыкания. Правый клик — удалить точку.',
  'golf.map.edit_alert_area_details': 'Редактировать параметры зоны оповещения',
  'golf.map.edit_area_details': 'Редактировать параметры зоны',
  'golf.map.failed_delete_alert_area': 'Не удалось удалить зону оповещения',
  'golf.map.failed_delete_area': 'Не удалось удалить зону',
  'golf.map.failed_load_alert_areas': 'Не удалось загрузить зоны оповещения',
  'golf.map.failed_load_areas': 'Не удалось загрузить зоны',
  'golf.map.failed_save_alert_area': 'Не удалось сохранить зону оповещения',
  'golf.map.failed_save_area': 'Не удалось сохранить зону',
  'golf.map.finish_drawing': 'Завершить рисование',
  'golf.map.finish_editing_first':
    'Пожалуйста, сначала завершите редактирование текущей зоны',
  'golf.map.geographic_areas': 'Географические зоны',
  'golf.map.golf_car_title': 'Гольф-кар — {name}',
  'golf.map.initializing_map': 'Инициализация карты...',
  'golf.map.loading_map': 'Загрузка карты...',
  'golf.map.no_alert_areas_found': 'Зоны оповещения не найдены.',
  'golf.map.no_areas_found': 'Зоны не найдены.',
  'golf.map.parking_areas': 'Зоны парковки',
  'golf.map.refresh_map': 'Обновить карту',
  'golf.map.title': 'Карта',
  'golf.map.total_golf_cars': 'Всего гольф-каров:',
  'golf.map.visible': 'Видимые:',
  'golf.map.zoom_in': 'Приблизить',
  'golf.map.zoom_out': 'Отдалить',
  'golf.menu.alert_areas': 'Зоны оповещения',
  'golf.menu.areas': 'Зоны',
  'golf.menu.brand': 'Breeze Golf',
  'golf.menu.brand_subtitle': 'Кабинет руководителя',
  'golf.menu.dashboard': 'Панель управления',
  'golf.menu.financial_reports': 'Финансовые отчеты и биллинг',
  'golf.menu.fleet': 'Управление автопарком',
  'golf.menu.fleet_typo': 'Управление автопарком',
  'golf.menu.map': 'Карта',
  'golf.menu.reserves': 'Бронирования',
  'golf.menu.settings': 'Настройки',
  'golf.menu.switch_ev': 'EV-МОДУЛЬ',
  'golf.menu.switch_golf': 'ГОЛЬФ-МОДУЛЬ',
  'golf.menu.switch_p2p': 'P2P-МОДУЛЬ',
  'golf.menu.tariffs_settings': 'Тарифы и настройки',
  'golf.menu.trips': 'Поездки',
  'golf.menu.user_role': 'Роли пользователей',
  'golf.menu.users': 'Пользователи',
  'golf.menu.users_access': 'Роли пользователей',
  'golf.promo.action_pause': 'Приостановить',
  'golf.promo.action_resume': 'Возобновить',
  'golf.promo.action_stop': 'Остановить',
  'golf.promo.active': 'Активна',
  'golf.promo.active_campaigns': 'Активные кампании',
  'golf.promo.add_discount': 'Добавить новую скидку',
  'golf.promo.all_campaigns': 'Все промокампании',
  'golf.promo.all_statuses': 'Все статусы',
  'golf.promo.all_users': 'Все пользователи',
  'golf.promo.always_active': 'Всегда активна',
  'golf.promo.applies_to_all_tariffs_default':
    'По умолчанию применяется ко всем тарифам',
  'golf.promo.btn_auto_generate': 'Сгенерировать автоматически',
  'golf.promo.btn_create_campaign': 'Создать кампанию',
  'golf.promo.budget_limit': 'Лимит бюджета (₼)',
  'golf.promo.budget_prefix': 'Бюджет:',
  'golf.promo.bulk_generate': 'Массовая генерация',
  'golf.promo.bulk_generate_title': 'Массовая генерация 12-значных промокодов',
  'golf.promo.campaign_name': 'Название кампании',
  'golf.promo.col_code_campaign': 'КОД И КАМПАНИЯ',
  'golf.promo.col_conditions': 'УСЛОВИЯ',
  'golf.promo.col_discount': 'СКИДКА',
  'golf.promo.col_usages_budget': 'ИСПОЛЬЗОВАНИЯ И БЮДЖЕТ',
  'golf.promo.col_validity': 'СРОК ДЕЙСТВИЯ',
  'golf.promo.completed_redemptions': 'Использования в завершенных поездках',
  'golf.promo.copy_code': 'Копировать код',
  'golf.promo.create_promo_code': 'Создать промокод',
  'golf.promo.currently_redeemable': 'Сейчас доступны гостям',
  'golf.promo.customer_savings': 'ОБЩАЯ ЭКОНОМИЯ КЛИЕНТОВ',
  'golf.promo.dialog_create_campaign': 'Создать промокампанию',
  'golf.promo.discount': 'СКИДКА',
  'golf.promo.discount_type': 'Тип скидки',
  'golf.promo.discount_value': 'Размер скидки',
  'golf.promo.eg_campaign_name': 'напр., Летний Golf Open 2026',
  'golf.promo.export_csv': 'Экспорт в CSV',
  'golf.promo.failed_save_promo': 'Не удалось сохранить промокод',
  'golf.promo.failed_stop_promo': 'Не удалось остановить промокод',
  'golf.promo.fixed_amount': 'Фиксированная сумма (₼)',
  'golf.promo.label_applicable_tariffs': 'Применимые тарифы',
  'golf.promo.label_code_12_chars': 'Промокод (12 символов)',
  'golf.promo.label_max_discount_cap': 'Максимальная скидка (₼)',
  'golf.promo.label_min_order': 'Минимальная сумма заказа (₼)',
  'golf.promo.label_restrict_new_users':
    'Только для впервые арендующих (новые пользователи)',
  'golf.promo.label_usage_limit_total': 'Лимит использований (всего)',
  'golf.promo.label_valid_from': 'Действует с',
  'golf.promo.label_valid_until': 'Действует до',
  'golf.promo.max_prefix': 'Макс.:',
  'golf.promo.min_prefix': 'Мин.:',
  'golf.promo.must_be_12_chars':
    'Должен состоять из 12 заглавных букв или цифр.',
  'golf.promo.new_users_only': 'Только новые пользователи',
  'golf.promo.no_promo_codes_found': 'Промокоды не найдены',
  'golf.promo.paused': 'Приостановлена',
  'golf.promo.percentage': 'Процент (%)',
  'golf.promo.placeholder_12_chars': 'КОД ИЗ 12 СИМВОЛОВ',
  'golf.promo.placeholder_optional_cap': 'Необязательный лимит',
  'golf.promo.placeholder_optional_min': 'Необязательный минимум',
  'golf.promo.placeholder_unlimited': 'Без ограничений, если пусто',
  'golf.promo.prefix_max6': 'Префикс (макс. 6)',
  'golf.promo.promo_code': 'Промокод',
  'golf.promo.promo_code_saved': 'Промокод успешно создан',
  'golf.promo.promo_codes': 'Промокоды',
  'golf.promo.search_placeholder': 'Поиск по коду или кампании...',
  'golf.promo.spent_budget': 'Израсходованный бюджет',
  'golf.promo.status_expired': 'Истек',
  'golf.promo.status_stopped': 'Остановлена',
  'golf.promo.subtitle':
    'Управляйте 12-символьными промокампаниями, размерами скидок, лимитами бюджета и статусами.',
  'golf.promo.target_audience': 'Целевая аудитория',
  'golf.promo.title': 'Система промокодов',
  'golf.promo.total_active_label': 'Всего активных:',
  'golf.promo.total_campaigns': 'Всего кампаний',
  'golf.promo.total_cumulative_discount': 'Общая сумма предоставленных скидок',
  'golf.promo.total_redemptions_label': 'Всего использований:',
  'golf.promo.total_usages': 'Всего использований',
  'golf.promo.uses': 'Использований:',
  'golf.promo.validity_window': 'Срок действия',
  'golf.promo.wallet_credit': 'Пополнение кошелька (₼)',
  'golf.reserves.active_reservations': 'АКТИВНЫЕ БРОНИРОВАНИЯ',
  'golf.reserves.failed_load_reserves': 'Не удалось загрузить бронирования',
  'golf.reserves.filter_payment': 'Фильтр по оплате',
  'golf.reserves.no_active_reservations': 'Нет активных бронирований',
  'golf.reserves.reservation_info': 'Информация о бронировании',
  'golf.reserves.title': 'Бронирования',
  'golf.reserves.upcoming_cancelled_desc':
    'Предстоящие или отмененные бронирования этого пользователя.',
  'golf.roles.access_except_users':
    'Доступ ко всем модулям, КРОМЕ пользователей и управления доступом',
  'golf.roles.access_revoked': 'Доступ отозван',
  'golf.roles.admin': 'Администратор',
  'golf.roles.col_last_active_timestamp': 'ПОСЛЕДНЯЯ АКТИВНОСТЬ',
  'golf.roles.col_module_permissions': 'ДОСТУП К МОДУЛЯМ',
  'golf.roles.col_team_member': 'УЧАСТНИК КОМАНДЫ',
  'golf.roles.edit_team_member': 'Редактировать участника команды',
  'golf.roles.eg_email': 'name@company.com',
  'golf.roles.eg_first_name': 'напр., Иван',
  'golf.roles.eg_last_name': 'напр., Иванов',
  'golf.roles.email': 'Электронная почта',
  'golf.roles.failed_revoke': 'Не удалось отозвать доступ',
  'golf.roles.failed_update_role': 'Не удалось обновить роль',
  'golf.roles.full_system_access': 'Полный доступ к системе во всех модулях',
  'golf.roles.invitation_sent': 'Приглашение успешно отправлено',
  'golf.roles.invite_team_member': 'Пригласить нового участника команды',
  'golf.roles.name': 'Имя',
  'golf.roles.operator': 'Оператор',
  'golf.roles.operator_access_desc':
    'Только Панель управления, Поездки, Автопарк. Тарифы, Пользователи и ручные платежи заблокированы.',
  'golf.roles.revoke_access': 'Отозвать доступ',
  'golf.roles.role': 'Роль',
  'golf.roles.role_admin_desc': 'Все модули включены',
  'golf.roles.role_blocked_desc':
    '(Тарифы, Пользователи и ручные платежи заблокированы)',
  'golf.roles.role_operator_desc':
    'Только Панель управления, Поездки, Управление автопарком',
  'golf.roles.role_supervisor_desc':
    'Панель управления, Поездки, Управление автопарком, Финансовые отчеты и биллинг (раздел «Пользователи» отключен)',
  'golf.roles.select_role': 'Выберите роль',
  'golf.roles.send_secure_token':
    'Отправьте по электронной почте защищенный токен для подключения к системе',
  'golf.roles.supervisor': 'Супервайзер',
  'golf.roles.title': 'Роли пользователей',
  'golf.roles.total_active_admins':
    'Всего активных учетных записей администраторов:',
  'golf.roles.total_active_field': 'Всего активных сотрудников на местах:',
  'golf.roles.update_role_for': 'Обновить роль для {name}',
  'golf.roles.user_role_updated': 'Роль пользователя обновлена',
  'golf.tariffs.applies_strictly_first_hour':
    'Применяется исключительно к первому часу аренды.',
  'golf.tariffs.base_hourly_rate': 'Базовая почасовая ставка (₼)',
  'golf.tariffs.base_weekend_rate': 'Базовая ставка в выходные — Пт–Вс (₼)',
  'golf.tariffs.base_workday_rate': 'Базовая ставка в будни — Пн–Чт (₼)',
  'golf.tariffs.create_tariff': 'Создать тариф',
  'golf.tariffs.daily_price_calibration': 'Настройка посуточных цен',
  'golf.tariffs.daily_price_calibration_desc':
    'Задайте базовые суточные ставки и прогрессивные скидки на долгосрочную аренду.',
  'golf.tariffs.daily_pricing': 'Посуточные цены',
  'golf.tariffs.durations_min': 'Доступная длительность (мин)',
  'golf.tariffs.eligibility_guards': 'Условия допуска и гарантийный депозит',
  'golf.tariffs.eligibility_guards_desc':
    'Управление рисками и правила финансовой безопасности.',
  'golf.tariffs.failed_update_tariff': 'Не удалось обновить тариф',
  'golf.tariffs.fixed_30min_help':
    'Фиксированная базовая цена, применяемая автоматически, когда пользователь выбирает короткий 30-минутный пакет аренды.',
  'golf.tariffs.fixed_30min_rate': 'Фиксированная ставка за пакет 30 мин (₼)',
  'golf.tariffs.fixed_security_deposit':
    'Фиксированный гарантийный депозит (₼)',
  'golf.tariffs.formula_preview_for': 'Предпросмотр формулы для {model}:',
  'golf.tariffs.global_tariffs': 'Общие тарифы',
  'golf.tariffs.hourly_price_calibration': 'Настройка почасовых цен',
  'golf.tariffs.hourly_pricing': 'Почасовые цены',
  'golf.tariffs.hours_formula_preview': '{hours} ч = {formula}',
  'golf.tariffs.per_day': '/сутки',
  'golf.tariffs.per_hour': '/час',
  'golf.tariffs.short_term_economics_desc':
    'Определите условия краткосрочной аренды для гостей.',
  'golf.tariffs.subsequent_hour_discount': 'Скидка на последующие часы (%)',
  'golf.tariffs.subsequent_hour_discount_help':
    'Фиксированная скидка, применяемая только к часам после первого часа.',
  'golf.tariffs.tariff_save_failed': 'Не удалось сохранить конфигурацию.',
  'golf.tariffs.tariff_saved_success': 'Конфигурация успешно сохранена.',
  'golf.tariffs.tier_1': 'Уровень 1 (2–7 дней)',
  'golf.tariffs.tier_2': 'Уровень 2 (8–14 дней)',
  'golf.tariffs.tier_3': 'Уровень 3 (15–30 дней)',
  'golf.tariffs.tier_4': 'Уровень 4 (от 31 дня)',
  'golf.tariffs.title': 'Тарифы и настройки',
  'golf.tariffs.weekend': 'Выходные',
  'golf.tariffs.weekend_rate_label': 'Ставка в выходные (₼)',
  'golf.tariffs.workday': 'Будний день',
  'golf.tariffs.workday_rate_label': 'Ставка в будни (₼)',
  'golf.tariffs.your_savings': '(Ваша экономия: {amount})',
  'golf.trips.account_verified': 'Учетная запись подтверждена',
  'golf.trips.accumulated_extensions': 'Суммарное продление поездки',
  'golf.trips.action_col': 'Действие',
  'golf.trips.action_required': 'ТРЕБУЕТСЯ ДЕЙСТВИЕ',
  'golf.trips.actions': 'Действия',
  'golf.trips.actor_col': 'Исполнитель',
  'golf.trips.additional_charge_applied': 'Начислена дополнительная плата.',
  'golf.trips.after_trip_photos': 'Фото после поездки',
  'golf.trips.amounts_label': 'Суммы',
  'golf.trips.approve': 'Одобрить',
  'golf.trips.assign_model': 'Назначить модель',
  'golf.trips.assigned_stall': 'Назначенное парковочное место',
  'golf.trips.base_rate_label': 'Базовая ставка',
  'golf.trips.base_rental_service_fee': 'Базовая плата за аренду',
  'golf.trips.booking_details': 'Детали бронирования',
  'golf.trips.cancel_trip': 'Отменить поездку',
  'golf.trips.cash': 'НАЛИЧНЫЕ',
  'golf.trips.cash_payment_notice':
    'Эта поездка была оплачена наличными в кассе. Операции блокировки или списания по карте не проводились.',
  'golf.trips.change_model_manually': 'Изменить модель вручную',
  'golf.trips.charge_amount': 'Сумма списания',
  'golf.trips.comment_col': 'Комментарий',
  'golf.trips.complete_trip': 'Завершить поездку',
  'golf.trips.confirm_cash_settlement': 'ПОДТВЕРДИТЬ РАСЧЕТ НАЛИЧНЫМИ',
  'golf.trips.credit': 'КАРТА',
  'golf.trips.current_status': 'ТЕКУЩИЙ СТАТУС',
  'golf.trips.daily_rental': 'ПОСУТОЧНАЯ АРЕНДА',
  'golf.trips.date_col': 'Дата',
  'golf.trips.decline': 'Отклонить',
  'golf.trips.deposit': 'Депозит',
  'golf.trips.discounts_applied': 'Примененные скидки',
  'golf.trips.extended_by_user': 'Продлено пользователем',
  'golf.trips.failed_assign_model': 'Не удалось назначить модель',
  'golf.trips.failed_copy_id': 'Не удалось скопировать ID',
  'golf.trips.financials': 'Финансы',
  'golf.trips.finish_log_transaction': 'ЗАВЕРШИТЬ И ЗАФИКСИРОВАТЬ ТРАНЗАКЦИЮ',
  'golf.trips.freeze_amount': 'Сумма блокировки',
  'golf.trips.freeze_order_id': 'ID заказа на блокировку',
  'golf.trips.hourly_rental': 'ПОЧАСОВАЯ АРЕНДА',
  'golf.trips.id_copied': 'ID скопирован в буфер обмена',
  'golf.trips.is_cash': 'Наличными',
  'golf.trips.lifecycle_status': 'Статус поездки',
  'golf.trips.lifestyle_status': 'Статус поездки',
  'golf.trips.live_preview_box': 'ПРЕДПРОСМОТР В РЕАЛЬНОМ ВРЕМЕНИ',
  'golf.trips.log_booking_approved': 'Бронирование одобрено',
  'golf.trips.log_booking_created': 'Бронирование создано',
  'golf.trips.log_booking_declined': 'Бронирование отклонено',
  'golf.trips.log_trip_cancelled': 'Поездка отменена',
  'golf.trips.log_trip_completed': 'Поездка завершена',
  'golf.trips.log_trip_put_on_hold': 'Поездка приостановлена',
  'golf.trips.log_trip_resumed': 'Поездка возобновлена',
  'golf.trips.log_trip_started': 'Поездка началась',
  'golf.trips.manual_desk_reconciliation': 'Ручная сверка по этой поездке',
  'golf.trips.model_assigned_success': 'Модель успешно назначена для поездки',
  'golf.trips.model_id': 'ID модели',
  'golf.trips.no_aftertrip_photos': 'Нет фото после поездки',
  'golf.trips.no_logs_available': 'Для этой поездки нет записей в журнале',
  'golf.trips.no_pretrip_photos': 'Нет фото до поездки',
  'golf.trips.no_trips_found': 'Поездки не найдены',
  'golf.trips.payment_details': 'Детали платежа',
  'golf.trips.payment_id': 'ID платежа',
  'golf.trips.payment_method': 'Способ оплаты',
  'golf.trips.payment_status': 'Статус оплаты',
  'golf.trips.per_minute_rental': 'ПОМИНУТНАЯ АРЕНДА',
  'golf.trips.pickup': 'ВЫДАЧА',
  'golf.trips.post_trip_return': 'ВОЗВРАТ ПОСЛЕ ПОЕЗДКИ',
  'golf.trips.pre_trip_photos': 'Фото до поездки',
  'golf.trips.pre_trip_verification': 'ПРОВЕРКА ПЕРЕД ПОЕЗДКОЙ',
  'golf.trips.put_on_hold': 'Приостановить',
  'golf.trips.refund_amount': 'Сумма возврата',
  'golf.trips.renter_profile': 'Профиль арендатора',
  'golf.trips.resume_trip': 'Возобновить поездку',
  'golf.trips.return': 'ВОЗВРАТ',
  'golf.trips.seats': 'Количество мест',
  'golf.trips.select_available_model_placeholder':
    'Выберите доступную модель...',
  'golf.trips.select_model_catalog': 'ВЫБЕРИТЕ ДОСТУПНУЮ МОДЕЛЬ В СИСТЕМЕ',
  'golf.trips.showing_active_models_fleet':
    'Отображаются все доступные для назначения активные модели автопарка.',
  'golf.trips.showing_results': 'Показаны результаты {start}–{end} из {total}',
  'golf.trips.stall': 'Место',
  'golf.trips.stall_number': 'Номер парковочного места',
  'golf.trips.start_trip': 'Начать поездку',
  'golf.trips.status_cancelled_admin': 'Отменено (администратор)',
  'golf.trips.status_cancelled_user': 'Отменено (пользователь)',
  'golf.trips.tab_all': 'Все поездки',
  'golf.trips.tab_approved': 'Одобренные',
  'golf.trips.tab_cancelled': 'Отмененные',
  'golf.trips.tab_completed': 'Завершенные',
  'golf.trips.tab_on_hold': 'Приостановленные',
  'golf.trips.tab_ongoing': 'Текущие',
  'golf.trips.tab_pending': 'Ожидающие',
  'golf.trips.title': 'Поездки',
  'golf.trips.total_amount_label': 'Общая сумма',
  'golf.trips.total_cash_due': 'ИТОГО К ОПЛАТЕ НАЛИЧНЫМИ',
  'golf.trips.total_credit_due': 'ИТОГО К ОПЛАТЕ КАРТОЙ',
  'golf.trips.trigger_action': 'ВЫПОЛНИТЬ ДЕЙСТВИЕ',
  'golf.trips.trip_details': 'Детали поездки',
  'golf.trips.trip_extended_user': 'Поездка продлена пользователем',
  'golf.trips.trip_finance': 'ФИНАНСЫ ПОЕЗДКИ',
  'golf.trips.trip_logs': 'ЖУРНАЛ ПОЕЗДКИ',
  'golf.trips.trip_photos': 'ФОТО ПОЕЗДКИ',
  'golf.trips.trip_status': 'Статус поездки',
  'golf.trips.trip_total': 'Итого за поездку',
  'golf.trips.vehicle_model': 'Модель гольф-кара',
  'golf.trips.view_details': 'Подробнее',
  'golf.users.account_profile': 'ПРОФИЛЬ УЧЕТНОЙ ЗАПИСИ',
  'golf.users.audit_documentation': 'ДОКУМЕНТЫ ДЛЯ ПРОВЕРКИ',
  'golf.users.balance': 'Баланс',
  'golf.users.base': 'Базовая',
  'golf.users.block': 'Заблокировать',
  'golf.users.copy_user_id': 'Скопировать ID пользователя',
  'golf.users.current_balance': 'Текущий баланс:',
  'golf.users.description': 'Описание',
  'golf.users.driver_license': 'Водительское удостоверение',
  'golf.users.failed_update_status': 'Не удалось обновить статус',
  'golf.users.filter_golf_status': 'Фильтр по гольф-статусу',
  'golf.users.golf_statistics': 'ГОЛЬФ-СТАТИСТИКА',
  'golf.users.identifications': 'ДОКУМЕНТЫ, УДОСТОВЕРЯЮЩИЕ ЛИЧНОСТЬ',
  'golf.users.last_trip_date': 'Дата последней поездки',
  'golf.users.latest_bookings_desc': 'Последние бронирования этого арендатора.',
  'golf.users.latest_reserves': 'Последние бронирования',
  'golf.users.linked_cards_desc':
    'Карты, привязанные к учетной записи арендатора.',
  'golf.users.loaded': 'загружено',
  'golf.users.no_cards_on_file': 'Нет сохраненных платежных карт',
  'golf.users.no_financial_operations':
    'Финансовые операции пока не зафиксированы',
  'golf.users.no_reserves_found':
    'Бронирований гольф-каров для этого пользователя не найдено',
  'golf.users.no_trips_recorded':
    'У этого арендатора нет зарегистрированных поездок',
  'golf.users.no_trips_yet': 'Поездок пока нет',
  'golf.users.not_set': 'Не указано',
  'golf.users.on_file': 'в системе',
  'golf.users.operation': 'Операция',
  'golf.users.outstanding_amount_warning':
    'Задолженность должна быть погашена, прежде чем пользователь сможет забронировать снова.',
  'golf.users.passport_id': 'Паспорт или удостоверение личности',
  'golf.users.payment_cards': 'Платежные карты',
  'golf.users.pricing': 'Тарификация',
  'golf.users.recent_trips': 'Последние поездки',
  'golf.users.renter_access_desc':
    'Этот пользователь имеет доступ к гольф-модулю и может бронировать поездки в качестве арендатора.',
  'golf.users.reserve': 'Бронирование',
  'golf.users.reserved_window': 'Период бронирования',
  'golf.users.title': 'Пользователи',
  'golf.users.total_trips': 'Всего поездок',
  'golf.users.trip': 'Поездка',
  'golf.users.unblock': 'Разблокировать',
  'golf.users.user_info': 'ДАННЫЕ ПОЛЬЗОВАТЕЛЯ',
  'golf.users.user_status_updated': 'Статус пользователя успешно обновлен',
  'golf.users.users_exported': 'Пользователи успешно экспортированы',
  'golf.users.wallet_state_desc':
    'Состояние кошелька арендатора по поездкам на гольф-карах.',
  'golf.users.years': 'лет',
  'golf.zones.title': 'Зона размещения на курорте',
}
export default ru
